import { useQuery } from '@tanstack/react-query';
import { getListPipelineRunsQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

// GET /api/pipelines/{id}/runs -> List<PipelineRunDto>, newest-first (AC-17). Also the
// lazy per-row fetch used by the list's latest-run-status cell (RV-1 / AC-2 / AC-11) —
// callers pass `enabled` to scope the fetch to visible/expanded rows only (NFR-Perf).
const useGetListPipelineRuns = (pipelineId, { enabled = true } = {}) => {
  return useQuery({
    queryKey: queryKeys.getRuns(pipelineId),
    queryFn: () => getListPipelineRunsQuery(pipelineId),
    enabled: !!pipelineId && enabled,
  });
};

export default useGetListPipelineRuns;
